import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import AddEditWhatsappMetaBroadcastModal from './AddEditWhatsappMetaBroadcastModal';
import MetaBroadcastInActiveList from './MetaBroadcastInActiveList';
import AdminHeader from '../../../components/header/AdminHeader';
import MetaBroadcastActiveList from './MetaBroadcastActiveList';
import { checkModulePermission } from '../../../utils/common';

import { useUserRolePermission } from '../../../store/slices/authSlice';

const WhatsappMetaBroadcast = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isApiCall, setIsApiCall] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [activeFilter, setActiveFilter] = useState(undefined);
  const [inActiveFilter, setInActiveFilter] = useState(undefined);

  const userRolePermission = useUserRolePermission();

  useEffect(() => {
    setActiveFilter(undefined);
    setInActiveFilter(undefined);
  }, [activeTab]);

  return (
    <div>
      <AdminHeader
        title="Whatsapp Meta Broadcast"
        isAdd
        isExpandSearch
        addBtnName="Add Whatsapp Meta Broadcast"
        onAddClick={() => setOpenAddModal(true)}
        isAddDisabled={
          !checkModulePermission('is_add', 'Whatsapp Meta Broadcast', userRolePermission)
        }
        searchPlaceholder="Search Broadcast"
        search={activeTab === '1' ? activeFilter : inActiveFilter}
        handelSearch={(e) => {
          if (activeTab === '1') {
            setActiveFilter(e.target.value);
          } else {
            setInActiveFilter(e.target.value);
          }
        }}
      />
      <div className="lists-container">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === '1' ? 'active' : ''}
              onClick={() => setActiveTab('1')}>
              Active Meta Broadcast
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === '2' ? 'active' : ''}
              onClick={() => setActiveTab('2')}>
              In-Active Meta Broadcast
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <MetaBroadcastActiveList
              activeTab={activeTab}
              isApiCall={isApiCall}
              setOpenAddModal={setOpenAddModal}
              setIsEdit={setIsEdit}
              setEditRecord={setEditRecord}
              search={activeFilter}
            />
          </TabPane>
          <TabPane tabId="2">
            <MetaBroadcastInActiveList
              activeTab={activeTab}
              isApiCall={isApiCall}
              setOpenAddModal={setOpenAddModal}
              setIsEdit={setIsEdit}
              setEditRecord={setEditRecord}
              search={inActiveFilter}
            />
          </TabPane>
        </TabContent>
      </div>
      {openAddModal && (
        <AddEditWhatsappMetaBroadcastModal
          isOpen={openAddModal}
          onCloseClick={(apiCall = false) => {
            setOpenAddModal(false);
            setEditRecord(null);
            setIsEdit(false);
            if (apiCall) {
              setIsApiCall(Math.random());
            }
          }}
          editRecord={editRecord}
          isEdit={isEdit}
        />
      )}
    </div>
  );
};

export default WhatsappMetaBroadcast;
